<template lang="pug">
  .menu-order(ref="menuOrder")
    .menu-order-item(@click="copyDataSky")
      .menu-order-item-text Copiar Skydropx
    .menu-order-item(@click="copyDataExcel")
      .menu-order-item-text Copiar Excel
    .menu-order-item(@click="copyDataUrl")
      .menu-order-item-text Copiar URL
    .menu-order-item(@click="cloneOrder")
      .menu-order-item-text Clonar Orden
    .menu-order-item(@click="openStaffRefund")
      .menu-order-item-text Generar reembolso
    .menu-order-item(@click="sendStatusNotification")
      .menu-order-item-text Enviar notificación de estado
    .menu-order-item(@click="openNotificationHistory")
      .menu-order-item-text Historial de notificaciones
</template>

<script>
export default {
  name: 'MenuOrder',

  props: {
    index: {
      type: Number,
      required: true
    }
  },

  methods: {
    copyDataSky () {
      this.$emit('copyDataSky')
      this.$store.commit('hideMenu', this.index)
    },
    copyDataExcel () {
      this.$emit('copyDataExcel')
      this.$store.commit('hideMenu', this.index)
    },
    copyDataUrl () {
      this.$emit('copyDataUrl')
      this.$store.commit('hideMenu', this.index)
    },
    cloneOrder () {
      this.$emit('cloneOrder')
      this.$store.commit('hideMenu', this.index)
    },

    openStaffRefund () {
      this.$emit('openStaffRefund')
      this.$store.commit('hideMenu', this.index)
    },

    sendStatusNotification () {
      this.$emit('sendStatusNotification')
      this.$store.commit('hideMenu', this.index)
    },

    openNotificationHistory () {
      this.$emit('openNotificationHistory')
      this.$store.commit('hideMenu', this.index)
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-order
  display flex
  flex-direction column
  border-radius 0.5em
  border 1px solid rgba(0,0,0,0.2)
  background-color #ffffff
  position absolute
  z-index 1000
  top 3em

.menu-order-item
  padding .5em 1em
  cursor pointer

.menu-order-item-text
  white-space nowrap

.menu-order-item:hover
  background-color rgba(0,0,0,0.1)

.menu-order-item-fraud .menu-order-item-text
  color #d9534f
  font-weight 600
</style>



// WEBPACK FOOTER //
// src/components/pages/order/MenuOrder.vue